export default __webpack_public_path__ + "static/media/honey comb.be980dff.svg";